import React from "react";

type VariantType = "required" | "optional";

interface CustomTagProps {
  type: VariantType;
}

const CustomTag: React.FC<CustomTagProps> = ({type}) => {
  const stylesBasedOnType: Record<VariantType, string> = {
    required: "text-[#F33D62] bg-[#FDE9E9]",
    optional: "text-[#343A3D] bg-[#E0E0E0]",
  };

  return (
    <div className={`h-[1.1875rem] px-2 py-0.5 flex items-center text-[0.625rem] font-normal text-center rounded-2xl ${stylesBasedOnType[type]}`}>
      {type === "required" ? "必須" : "明示事項"}
    </div>
  );
};

export default CustomTag;
